<template>
  <div>
    <CustomCheckBox
      v-for="item in checkboxes"
      :key="item.id"
      :label="item.value"
      :value="item.value"
      :id="item.value"
      :name="item.name"
      :content="item.name"
      v-model="item.checked"
    />
  </div>
  <h2>{{ selectedAnimals }}</h2>
</template>

<script>
import CustomCheckBox from '@/components/common/CustomCheckBox.vue';

export default {
  name: 'CheckboxesExample',
  components: { CustomCheckBox },
  data() {
    return {
      checkboxes: [
        {
          name: 'animals',
          value: 'dog',
          checked: false,
        }, {
          name: 'animals',
          value: 'cat',
          checked: false,
        }, {
          name: 'animals',
          value: 'horse',
          checked: false,
        },
      ],
    };
  },
  computed: {
    selectedAnimals() {
      return this.checkboxes.filter(c => c.checked).map(c => c.value);
    },
  },
};
</script>
